var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isPara &&
      _vm.isExisteParcela &&
      _vm.antecipacaoAtiva &&
      !_vm.dadosVtn.isQuitadoParcelas &&
      !_vm.excedente &&
      !_vm.resumo &&
      _vm.dadosVtn.formaPagamento !== "A_VISTA"
        ? _c(
            "div",
            [
              _c("app-antecipacao-vtn", {
                attrs: { dadosVtn: _vm.dadosVtn, showGestaoVtn: true }
              })
            ],
            1
          )
        : _vm._e(),
      _c("app-divider", {
        staticClass: "margin10",
        attrs: { label: "Dados Cálculo" }
      }),
      _vm.isMaranhao
        ? _c(
            "div",
            { staticClass: "card-body margin10" },
            [
              _vm.dadosVtn.municipio
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            attrs: {
                              label: "Município:",
                              content: _vm.dadosVtn.municipio.nome
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            attrs: {
                              label: "Área requerida:",
                              content:
                                _vm.formatarNumero(
                                  _vm.dadosVtn.areaRequerida,
                                  4
                                ) + " ha"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Valor de referência por Ha:",
                          content:
                            "R$ " +
                            _vm.formatarNumero(
                              _vm.dadosVtn.calculosVtn.valorReferencia,
                              2
                            )
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "VTN:",
                          content:
                            "R$ " +
                            _vm.formatarNumero(
                              _vm.dadosVtn.calculosVtn.valorVtn,
                              2
                            )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Taxas diversas:",
                          content:
                            "R$ " +
                            (_vm.dadosVtn.calculosVtn.taxaDiversa
                              ? _vm.formatarNumero(
                                  _vm.dadosVtn.calculosVtn.valorVtn * 0.1,
                                  2
                                )
                              : "0,00")
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Valor de referência do imóvel:",
                          content:
                            "R$ " +
                            _vm.formatarNumero(
                              _vm.dadosVtn.calculosVtn.valorReferenciaImovel,
                              2
                            )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.parcelasGeo && !_vm.isMaranhao
        ? _c(
            "div",
            { staticClass: "card-body margin10" },
            [
              _vm.dadosVtn.municipio
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            attrs: {
                              label: "Município:",
                              content: _vm.dadosVtn.municipio.nome
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-display", {
                            attrs: {
                              label: "Região:",
                              content: _vm.dadosVtn.municipio.regiao
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.dadosVtn.areaRequerida
                        ? _c("app-display", {
                            attrs: {
                              label: "Sr - Área requerida:",
                              content:
                                _vm.formatarNumero(
                                  _vm.dadosVtn.areaRequerida,
                                  4
                                ) + " ha"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.dadosVtn.fatorDistancia &&
                      _vm.dadosVtn.fatorDistancia.indice
                        ? _c("app-display", {
                            attrs: {
                              label: "IFa - Distância:",
                              content: _vm._f("formatDouble")(
                                _vm.dadosVtn.fatorDistancia.indice
                              ),
                              textIcon: _vm.dadosVtn.fatorDistancia.descricao,
                              toolTip: "right"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.dadosVtn.fatorAcesso
                        ? _c("app-display", {
                            attrs: {
                              label: "IFb - Acesso à área:",
                              content: _vm._f("formatDouble")(
                                _vm.dadosVtn.fatorAcesso.indice
                              ),
                              textIcon: _vm.dadosVtn.fatorAcesso.descricao,
                              toolTip: "right"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.dadosVtn.fatorTempoOcupacao
                        ? _c("app-display", {
                            attrs: {
                              label: "IFc - Ancianidade da ocupação:",
                              content: _vm._f("formatDouble")(
                                _vm.dadosVtn.fatorTempoOcupacao.indice
                              ),
                              textIcon:
                                _vm.dadosVtn.fatorTempoOcupacao.descricao,
                              toolTip: "right"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.dadosVtn.calculosVtn && !_vm.excedente
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.vdr
                            ? _c("app-display", {
                                attrs: {
                                  label:
                                    "VDR - Valor de referência correspondente à dimensão da propriedade:",
                                  content: _vm._f("formatDouble")(
                                    _vm.dadosVtn.vdr
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.indiceArea
                            ? _c("app-display", {
                                attrs: {
                                  label: "IFd - Dimensão da área:",
                                  content: _vm._f("formatDouble")(
                                    _vm.dadosVtn.calculosVtn.indiceArea
                                  ),
                                  textIcon: _vm.textoIfd,
                                  toolTip: "top"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.numeroMf
                            ? _c("app-display", {
                                attrs: {
                                  label: "Número de módulos fiscais:",
                                  content: _vm._f("formatDouble")(
                                    _vm.dadosVtn.calculosVtn.numeroMf
                                  ),
                                  textIcon: "Área requerida / MF",
                                  toolTip: "right"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dadosVtn.calculosVtn
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.mf
                            ? _c("app-display", {
                                attrs: {
                                  label: "MF - Módulo fiscal do município:",
                                  content: _vm._f("formatDouble")(
                                    _vm.dadosVtn.calculosVtn.mf
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.vrt
                            ? _c("app-display", {
                                attrs: {
                                  label:
                                    "VrT - Valor de Referência da terra para o município:",
                                  content: _vm.formatTotal(
                                    _vm.dadosVtn.calculosVtn.vrt
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dadosVtn.calculosVtn
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.vtn
                            ? _c("app-display", {
                                attrs: {
                                  label: "VTN - Valor da terra nua:",
                                  content: _vm.formatTotal(
                                    _vm.dadosVtn.calculosVtn.vtn
                                  ),
                                  textIcon:
                                    _vm.dadosVtn.calculosVtn.formulaCalculoVTN,
                                  toolTip: "right"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.vtn
                            ? _c("app-display", {
                                attrs: {
                                  label: "Tempo de ocupação:",
                                  content: _vm.formataAnos(
                                    _vm.dadosVtn.calculosVtn.tempoDeOcupacao
                                  ),
                                  textIcon: "Tempo de ocupação em anos",
                                  toolTip: "right"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dadosVtn.calculosVtn
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.valorTotalCustasProcessuais
                            ? _c("app-display", {
                                attrs: {
                                  label: "Custas processuais:",
                                  content: _vm.isExcedente
                                    ? "R$ 0,00"
                                    : _vm.formatTotal(
                                        _vm.dadosVtn.calculosVtn
                                          .valorTotalCustasProcessuais
                                      )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.valorTotalCustasAgrarias
                            ? _c("app-display", {
                                attrs: {
                                  label: "Custas agrárias:",
                                  content: _vm.isExcedente
                                    ? "R$ 0,00"
                                    : _vm.formatTotal(
                                        _vm.dadosVtn.calculosVtn
                                          .valorTotalCustasAgrarias
                                      )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dadosVtn.calculosVtn
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.tipoProcesso === "ONEROSO"
                            ? _c("app-display", {
                                attrs: {
                                  label: "Taxa de ocupação:",
                                  content: _vm.isExcedente
                                    ? "R$ 0,00"
                                    : _vm.formatTotal(
                                        _vm.dadosVtn.calculosVtn
                                          .valorTaxaOcupacao
                                      ),
                                  textIcon:
                                    "Para áreas até 100 ha não será cobrado taxa de ocupação. Para as demais, a taxa de ocupação será calculada pela fórmula VTN*(Tempo de ocupação/200)",
                                  toolTip: "right"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          !_vm.dadosVtn.calculosVtn.valorTotalCustasProcessuais
                            ? _c("app-display", {
                                attrs: {
                                  label: "Custas processuais:",
                                  content: _vm.excedente
                                    ? "R$ 0,00"
                                    : _vm.formatTotal(
                                        _vm.dadosVtn.calculosVtn
                                          .valorTotalCustasProcessuais
                                      )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.valorVistoriaRemota
                            ? _c("app-display", {
                                attrs: {
                                  label: "Custas vistoria remota:",
                                  content: _vm.formatTotal(
                                    _vm.dadosVtn.calculosVtn.valorVistoriaRemota
                                  ),
                                  textIcon:
                                    "Valor referente a elaboração da vistoria remota",
                                  toolTip: "right"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.dadosVtn.calculosVtn.valorVistoriaRemota
                            ? _c("app-display", {
                                attrs: {
                                  label: "Custas vistoria remota:",
                                  content: _vm.formatTotal(
                                    _vm.dadosVtn.calculosVtn.valorVistoriaRemota
                                  ),
                                  textIcon:
                                    "Valor referente a elaboração da vistoria remota",
                                  toolTip: "right"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : !_vm.isMaranhao
        ? _c(
            "div",
            { staticClass: "card-body margin10" },
            [
              _vm._l(_vm.parcelasGeo, function(parcela) {
                return _c(
                  "div",
                  [
                    parcela.municipio
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("app-display", {
                                  attrs: {
                                    label: "Município:",
                                    content: parcela.municipio.nome
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("app-display", {
                                  attrs: {
                                    label: "Região:",
                                    content: parcela.municipio.regiao
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            parcela.areaRequerida
                              ? _c("app-display", {
                                  attrs: {
                                    label: "Sr - Área requerida:",
                                    content:
                                      (_vm.isSegundoExcedente > 0
                                        ? _vm.formatarNumero(
                                            _vm.areaExcedente,
                                            4
                                          )
                                        : _vm.formatarNumero(
                                            parcela.areaRequerida,
                                            4
                                          )) + " ha"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            parcela.fatorDistancia &&
                            parcela.fatorDistancia.indice
                              ? _c("app-display", {
                                  attrs: {
                                    label: "IFa - Distância:",
                                    content: _vm._f("formatDouble")(
                                      parcela.fatorDistancia.indice
                                    ),
                                    textIcon: parcela.fatorDistancia.descricao,
                                    toolTip: "right"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            parcela.fatorAcesso
                              ? _c("app-display", {
                                  attrs: {
                                    label: "IFb - Acesso à área:",
                                    content: _vm._f("formatDouble")(
                                      parcela.fatorAcesso.indice
                                    ),
                                    textIcon: parcela.fatorAcesso.descricao,
                                    toolTip: "right"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _vm.dadosVtn.fatorTempoOcupacao
                              ? _c("app-display", {
                                  attrs: {
                                    label: "IFc - Ancianidade da ocupação:",
                                    content: _vm._f("formatDouble")(
                                      _vm.dadosVtn.fatorTempoOcupacao.indice
                                    ),
                                    textIcon:
                                      _vm.dadosVtn.fatorTempoOcupacao.descricao,
                                    toolTip: "right"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    parcela.vdr
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                parcela.vdr
                                  ? _c("app-display", {
                                      attrs: {
                                        label:
                                          "VDR - Valor de referência correspondente à dimensão da propriedade:",
                                        content: _vm._f("formatDouble")(
                                          parcela.vdr
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                parcela.indiceArea
                                  ? _c("app-display", {
                                      attrs: {
                                        label: "IFd - Dimensão da área:",
                                        content: _vm._f("formatDouble")(
                                          parcela.indiceArea
                                        ),
                                        textIcon: _vm.textoIfd,
                                        toolTip: "top"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                parcela.numeroMf
                                  ? _c("app-display", {
                                      attrs: {
                                        label: "Número de módulos fiscais:",
                                        content: _vm._f("formatDouble")(
                                          parcela.numeroMf
                                        ),
                                        textIcon: "Área requerida / MF",
                                        toolTip: "right"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    parcela
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                parcela.mf
                                  ? _c("app-display", {
                                      attrs: {
                                        label:
                                          "MF - Módulo fiscal do município:",
                                        content: _vm._f("formatDouble")(
                                          parcela.mf
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                parcela.vrt
                                  ? _c("app-display", {
                                      attrs: {
                                        label:
                                          "VrT - Valor de Referência da terra para o município:",
                                        content: _vm.formatTotal(parcela.vrt)
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("app-display", {
                                  attrs: {
                                    label: "VTN - Valor da terra nua:",
                                    content:
                                      "" +
                                      (_vm.isSegundoExcedente > 0
                                        ? _vm.formatTotal(_vm.valorTerraNua)
                                        : _vm.formatTotal(parcela.vtn)),
                                    textIcon:
                                      _vm.dadosVtn.calculosVtn
                                        .formulaCalculoVTN,
                                    toolTip: "right"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              attrs: {
                                label: "Tempo de ocupação:",
                                content: _vm.formataAnos(
                                  parcela.tempoDeOcupacao
                                ),
                                textIcon: "Tempo de ocupação em anos",
                                toolTip: "right"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c("hr")
            ],
            2
          )
        : _vm._e(),
      _vm.parcelasGeo
        ? _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Custas processuais:",
                          content: _vm.isExcedente
                            ? "R$ 0,00"
                            : _vm.formatTotal(
                                _vm.dadosVtn.calculosVtn
                                  .valorTotalCustasProcessuais
                              )
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Custas agrárias:",
                          content: _vm.isExcedente
                            ? "R$ 0,00"
                            : _vm.formatTotal(
                                _vm.dadosVtn.calculosVtn
                                  .valorTotalCustasAgrarias
                              )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.tipoProcesso === "ONEROSO"
                        ? _c("app-display", {
                            attrs: {
                              label: "Taxa de ocupação:",
                              content: _vm.isExcedente
                                ? "R$ 0,00"
                                : _vm.formatTotal(
                                    _vm.dadosVtn.calculosVtn.valorTaxaOcupacao
                                  ),
                              textIcon:
                                "Para áreas até 100 ha não será cobrado taxa de ocupação. Para as demais, a taxa de ocupação será calculada pela fórmula VTN*(Tempo de ocupação/200)",
                              toolTip: "right"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.dadosVtn.calculosVtn.valorVistoriaRemota
                        ? _c("app-display", {
                            attrs: {
                              label: "Custas vistoria remota:",
                              content: _vm.formatTotal(
                                _vm.dadosVtn.calculosVtn.valorVistoriaRemota
                              ),
                              textIcon:
                                "Valor referente a elaboração da vistoria remota",
                              toolTip: "right"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.isMaranhao
        ? _c("app-divider", {
            staticClass: "margin10",
            attrs: { label: "Observações:" }
          })
        : _vm._e(),
      !_vm.isMaranhao
        ? _c("div", { staticClass: "card-body margin10" }, [
            _c("p", [
              _vm._v(
                "- Cálculos efetuados com base no DECRETO Nº 1.684, de 29 de JUNHO de 2021; Lei Estadual nº 8.878, de 8 de julho de 2019 e DECRETO Nº 1.190, DE 25 / 11 / 2020."
              )
            ]),
            !_vm.isExcedente && _vm.tipoProcesso === "ONEROSO"
              ? _c("p", [
                  _vm._v(
                    "- Reajuste pela UPFPA do ano em vigor e, caso opte pelo pagamento parcelado, serão aplicados juros de " +
                      _vm._s(
                        _vm.dadosVtn.juros === null ? 0 : _vm.dadosVtn.juros
                      ) +
                      "% ao ano."
                  )
                ])
              : _vm._e(),
            !_vm.isExcedente &&
            _vm.tipoProcesso === "ONEROSO" &&
            !(
              _vm.dadosVtn.respeitaLegislacaoAmbiental &&
              _vm.dadosVtn.temDireitoRegularizacao
            )
              ? _c("p", [
                  _vm._v(
                    "- Caso opte pelo pagamento à vista, será aplicado um desconto de 20%."
                  )
                ])
              : _vm._e(),
            !_vm.isExcedente && _vm.dadosVtn.respeitaLegislacaoAmbiental
              ? _c("p", [
                  _vm._v("- " + _vm._s(_vm.mensagemRespeitaLegislacaoAmbiental))
                ])
              : _vm._e(),
            !_vm.isExcedente && _vm.dadosVtn.temDireitoRegularizacao
              ? _c("p", [
                  _vm._v("- " + _vm._s(_vm.mensagemDireitoRegularizacao))
                ])
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06347c87", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06347c87","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDadosCalculoVtn.vue
// module id = null
// module chunks = 